import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';

@Component({
    selector: 'rr-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent),
            multi: true,
        }
    ]
})
export class TextareaComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() label: string = '';
    @Input() FormControl: FormControl = new FormControl();
    @Input() placeholder: string = '';
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() value: any = '';
    @Input() fitText: boolean = false;
    @Input() btnIconEnd: string = '';
    @Input() btnType: string | undefined;
    @Input() btnText: string = '';
    @Input() btnIconStart: string = '';
    @Input() limitCharacters: number | undefined;
    @Input() maxheight: string | undefined;
    @Input() minheight: string = '140px';

    @Output() change: EventEmitter<any> = new EventEmitter();
    @Output() btnClick: EventEmitter<any> = new EventEmitter();

    errorClass: string = '';
    internValue: any;
    btnDisabeld: boolean = false;

    @ViewChild('textareaEl') textareaEl!: ElementRef<HTMLTextAreaElement>;


    ngOnInit() {
        if (this.required) {
            this.FormControl.setValidators(Validators.required);
        }
        if (this.FormControl) {
            this.value = this.FormControl.value;
            this.FormControl.valueChanges.subscribe((value) => {
                this.value = value;
                this.onChange(value);
                this.change.emit(value);
            });
        }
        this.checkValidation();
        this.chekValue()
    }

    ngAfterViewInit() {
        if (this.fitText === true) {
            this.resizeTextarea();

            this.FormControl.valueChanges.subscribe(() => {
                this.resizeTextarea();
            })
        }
    }
    public focus(): void {
        if (this.textareaEl && this.textareaEl.nativeElement) {
            this.textareaEl.nativeElement.focus();
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['value'] && changes['value'].currentValue !== undefined) {
            this.value = changes['value'].currentValue;
            this.FormControl.setValue(this.value);
        }
        if (changes['required']) {
            console.log('changes', this.value);
            if (changes['required'].currentValue === true) {
                setTimeout(() => {
                    // this.btnDisabeld = true;
                    this.chekValue();
                }, 0);
            }
        }

    }

    resizeTextarea() {
        const el = this.textareaEl?.nativeElement as HTMLTextAreaElement;
        if (!el) return;

        el.style.height = 'auto';

        // Force reflow um scrollHeight korrekt zu berechnen
        el.offsetHeight;

        const styles = window.getComputedStyle(el);
        const isBorderBox = styles.boxSizing === 'border-box';
        const border = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

        let newHeight = el.scrollHeight;

        // Optional: Maximal-Höhe berücksichtigen
        if (this.maxheight) {
            const maxHeightValue = parseFloat(this.maxheight);
            if (newHeight > maxHeightValue) {
                newHeight = maxHeightValue;
            }
        }

        el.style.height = `${newHeight}px`;
    }

    writeValue(value: any): void {
        this.internValue = value;
        this.FormControl.setValue(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onBtnClick() {
        if (this.required === true && this.value === '') {
            return;
        }

        this.btnClick.emit(this.value);
    }

    chekValue() {
        if (this.required === true && (this.value === '' || !this.value)) {
            this.btnDisabeld = true;
        } else {
            this.btnDisabeld = false;
        }
    }

    onChange: any = () => { };
    onTouched: any = () => { };

    async checkValidation() {
        if (this.required) {
            this.FormControl.setValidators([Validators.required]);
        }

        this.FormControl.updateValueAndValidity();
        if (this.FormControl.invalid) {
            this.errorClass = 'error';
            return false;
        }
        this.errorClass = '';
        return true;
    }
}
